var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from "react";
import { useLayer } from "react-laag";
import ResizeObserver from "resize-observer-polyfill";
import Text from "../text/Text";
import nextId from "react-id-generator";
var Tooltip = function (_a) {
    var children = _a.children, text = _a.text, content = _a.content, style = _a.style;
    var tooltipId = useMemo(function () { return nextId("oui-tooltip-id-"); }, []);
    var _b = React.useState(false), isOpen = _b[0], setOpen = _b[1];
    var _c = useLayer({
        isOpen: isOpen,
        placement: "right-center",
        triggerOffset: 4,
        auto: true,
        ResizeObserver: ResizeObserver,
        onOutsideClick: function () { return setOpen(false); },
    }), layerProps = _c.layerProps, triggerProps = _c.triggerProps, renderLayer = _c.renderLayer;
    return (React.createElement(React.Fragment, null,
        isOpen &&
            renderLayer(React.createElement("div", { ref: layerProps.ref, style: __assign(__assign(__assign({}, layerProps.style), { background: "hsla(0, 0%, 0%, 0.85)", padding: "0.5em 1em", borderRadius: 4, maxWidth: 240 }), style), id: tooltipId, role: "tooltip" }, content ? content : React.createElement(Text, { color: "white" }, text))),
        React.createElement("button", __assign({}, triggerProps, { onClick: function () { return setOpen(!isOpen); }, "aria-describedby": tooltipId, style: {
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
            } }), children)));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map